import React from "react";
import { Link } from "react-router-dom";
import Services from "../../api/service";

const Service = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section
      className={`${props.Fclass} section-padding  ${props.vclassClass}`}
    >
      <div className="container">
        <div className="row">
          {Services.slice(0, 3).map((service, sitem) => (
            <div className="col col-xl-4 col-lg-6 col-sm-6 col-12" key={sitem}>
              <div className="wpo-features-item">
                <div className="wpo-features-icon">
                  <div className="icon">
                    <i className="fi">{service.icon}</i>
                  </div>
                </div>
                <div
                  className="wpo-features-text"
                  style={{ position: "relative", zIndex: 1 }}
                >
                  <h2>
                    <Link
                      onClick={ClickHandler}
                      to={`/${service.id}`}
                    >
                      {service.title}
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Service;
